import CommunicationService from '../../../Utils/CommunicationService';

export interface IBugReport {
  type: string;
  title: string;
  url: string;
  user: string;
  description: string;
  fileBase64?: string;
  fileMime?: string;
  solved: boolean;
  creationDate?: string;
  solvingDate?: string;
}

export const reportBug = async ({
  type,
  title,
  url,
  user,
  description,
  fileBase64,
  fileMime,
  solved,
  creationDate,
  solvingDate,
}: IBugReport) => {
  const result = await CommunicationService.getInstance().secureCall<any>({
    type: 'PUT',
    path: '/api/bugReports',
    body: {
      type,
      title,
      url,
      user,
      description,
      fileBase64,
      fileMime,
      solved,
      creationDate,
      solvingDate,
    },
  });
  if (result.body) {
    return result.body;
  }
  return [];
};
